module.exports = __webpack_public_path__ + "static/img/12.817e4a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/12.png
// module id = FQHC
// module chunks = 0